/** ******** 配置资产、设置借出 弹窗相关 mixin **********/
import {mapActions, mapMutations, mapState} from 'vuex'
import {clone} from '@/assets/utils'
import Bus from '@/assets/utils/bus'

export default {
  props: {
    refreshIndex: { // 刷新弹窗
      type: Number,
      default: 0
    },
    configItem: { // 正在操作的行数据(用户信息)
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      selfAsset: 0,
      leftoverAsset: 0,
      model: {
        noAsset: false,
        hasAsset: false
      },
      errorType: 0,
      errorTips: {
        4001: '您没有选择借出锁，请选择', // 未选择借出锁
        4002: '您没有选择授权，请选择', // 未选择资产
        340022: '配置资产失败',
        340023: '查询企业下的可借出锁失败', // 设置借出
        340024: '设置借出失败', // 设置借出
        340025: '当前企业子账号匹配了多个员工',
        340026: '未找到资产编号',
        340027: '资产编号归属客户不正确',
        340028: '企业子账号未成功匹配员工', // 配置资产、设置借出
        340029: '资产编号重复配置',
        340030: '无效token',
        340031: '安全校验不通过',
        340032: '节点不足', // 设置借出
        340033: '员工权限不足', // 设置借出
        340034: '已经借出到其他借出锁', // 设置借出
        340035: '借出锁状态异常' // 设置借出
      },
      checkedBefore: {},
      assetList: [],
      addAsset: [], // 本次操作 增加的 资产 id 组
      deleteAsset: [], // 本次操作 删除的 资产 id 组
      checkedAssetChange: false,
      saving: false, // 正在保存 修改
      errorMessage: '', // 错误提示
      checkedAsset: []
    }
  },
  computed: {
    ...mapState({
      assetListReady: state => state.members.assetListReady,
      assetAll: state => state.members.assetAll
    })
  },
  created () {
    const start = Date.now()
    this.getAssetList(this.configItem).then(() => {
      this.checkedAsset = this.assetAll.filter(asset => {
        return asset.gldUserId === this.configItem.gldUserId
      }).map(asset => asset.assetNum)
      this.$nextTick(() => {
        this.sentLog(100117027, {duration: ((Date.now() - start) / 1000).toFixed(2)})
      })
    })
    // 设置借出 弹窗 获取企业可借出锁
    if (this.popType === 'Lent') {
      this.getUsbKey()
    }
    this.saving = false
  },
  methods: {
    ...mapActions({
      getAssetList: 'members/getAssetList',
      searchAssetList: 'members/searchAssetList'
    }),
    ...mapMutations({
      setAssetList: 'members/SET_ASSET_LIST'
    }),
    // 1. 左侧资产列表 选择状态变化时
    checkedChangeHandle ({list, checkedBefore}) {
      if (this.popType === 'Asset') {
        const addAsset = []
        const deleteAsset = [...this.deleteAsset]
        let checkedAfter = {}
        const tempObj = clone(checkedBefore)
        list.forEach((asset) => {
          if (asset.checked) {
            // 10.28 新增时，删除掉原有删除缓存数据中的记录
            if (deleteAsset.includes(asset.assetNum)) {
              deleteAsset.splice(deleteAsset.indexOf(asset.assetNum), 1)
            }
            checkedAfter[asset.assetId] = asset.assetNum
          } else {
            // 10.28
            // 列表中包含已选择的资产编号，但未选择，标记为需要删除的
            if (tempObj[asset.assetId]) {
              deleteAsset.push(tempObj[asset.assetId])
              delete tempObj[asset.assetId]
            }
          }
        })
        for (const key in checkedAfter) {
          if (tempObj[key]) {
            // 配置资产时 需要把之前配置的资产 也传过去
            if (this.popType === 'Asset') {
              addAsset.push(tempObj[key])
            } else {
              addAsset.push(key)
            }
          }
        }
        checkedAfter = Object.assign({}, tempObj, checkedAfter) // 10.28
        Bus.$emit('updateCheckedBefore', checkedAfter) // 10.28
        for (const key in checkedAfter) {
          if (this.popType === 'Lent') {
            addAsset.push(key)
          } else {
            addAsset.push(checkedAfter[key])
          }
        }
        this.addAsset = [...new Set(addAsset)]
        this.deleteAsset = [...new Set(deleteAsset)]
        this.errorType = 0
        this.checkedAssetChange = true
      } else {
        const addAsset = []
        const deleteAsset = []
        let checkedAfter = {}
        const tempObj = clone(checkedBefore)
        list.forEach((asset) => {
          if (asset.checked) {
            checkedAfter[asset.assetId] = asset.assetNum
          }
        })
        for (const key in checkedAfter) {
          if (tempObj[key]) {
            // 配置资产时 需要把之前配置的资产 也传过去
            if (this.popType === 'Asset') {
              addAsset.push(tempObj[key])
            } else {
              addAsset.push(key)
            }
            delete checkedAfter[key]
            delete tempObj[key]
          }
        }
        for (const key in checkedAfter) {
          if (this.popType === 'Lent') {
            addAsset.push(key)
          } else {
            addAsset.push(checkedAfter[key])
          }
        }
        for (const key in tempObj) {
          if (this.popType === 'Lent') {
            deleteAsset.push(key)
          } else {
            deleteAsset.push(tempObj[key])
          }
        }
        this.addAsset = addAsset
        this.deleteAsset = deleteAsset
        this.errorType = 0
        this.checkedAssetChange = true
      }
      // const addAsset = []
      // const deleteAsset = [...this.deleteAsset]
      // let checkedAfter = {}
      // const tempObj = clone(checkedBefore)
      // list.forEach((asset) => {
      //   if (asset.checked) {
      //     // 10.28 新增时，删除掉原有删除缓存数据中的记录
      //     if (deleteAsset.includes(asset.assetNum)) {
      //       deleteAsset.splice(deleteAsset.indexOf(asset.assetNum), 1)
      //     }
      //     checkedAfter[asset.assetId] = asset.assetNum
      //   } else {
      //     // 10.28
      //     // 列表中包含已选择的资产编号，但未选择，标记为需要删除的
      //     if (tempObj[asset.assetId]) {
      //       deleteAsset.push(tempObj[asset.assetId])
      //       delete tempObj[asset.assetId]
      //     }
      //   }
      // })
      // for (const key in checkedAfter) {
      //   if (tempObj[key]) {
      //     // 配置资产时 需要把之前配置的资产 也传过去
      //     if (this.popType === 'Asset') {
      //       addAsset.push(tempObj[key])
      //     } else {
      //       addAsset.push(key)
      //     }
      //     // 10.28
      //     // delete checkedAfter[key]
      //     // delete tempObj[key]
      //   }
      // }
      // checkedAfter = Object.assign({}, tempObj, checkedAfter) // 10.28
      // Bus.$emit('updateCheckedBefore', checkedAfter) // 10.28
      // for (const key in checkedAfter) {
      //   if (this.popType === 'Lent') {
      //     addAsset.push(key)
      //   } else {
      //     addAsset.push(checkedAfter[key])
      //   }
      // }
      // // for (const key in tempObj) {
      // //   if (this.popType === 'Lent') {
      // //     deleteAsset.push(key)
      // //   } else {
      // //     deleteAsset.push(tempObj[key])
      // //   }
      // // }
      // this.addAsset = [...new Set(addAsset)]
      // this.deleteAsset = [...new Set(deleteAsset)]
      // this.errorType = 0
      // this.checkedAssetChange = true
    },
    // 2. 已配置的资产数 和 可配置的资产数 设置
    listReadyHandle ({selfAsset, leftoverAsset, checkedBefore}) {
      this.leftoverAsset = leftoverAsset
      this.selfAsset = selfAsset
      this.checkedBefore = checkedBefore
    },
    showErrorMessage (type) {
      if (type in this.errorTips) {
        this.errorType = type
      } else {
        if (this.popType === 'Asset') {
          this.errorType = 340022
        } else {
          this.errorType = 340024
        }
      }
      let fnCode = 100117032
      if (this.popType === 'Asset') {
        fnCode = 100117030
      }
      this.sentLog(fnCode, {status: 2, message: this.errorTips[this.errorType]})
    },
    // 3.2 弹窗 取消
    cancel (type) {
      this.model[type] = false
      this.$emit('cancel', this.popType)
    }
  },
  watch: {
    assetListReady () {
      if (this.assetListReady) {
        this.showConfigPop()
      }
    },
    refreshIndex () {
      if (this.refreshIndex) {
        this.getAssetList(this.configItem)
      }
    }
  }
}
